export default "https://assets-v2.scaler.com/packs/files/psp-milestone-nudge.46a386.webp";